<template>
	<section :id="id"
	         class="content_section"
	         v-bind:class="{ image_section: isImage, inline_section: isInline, parallax_section: isParallax }"
	         v-bind:style="{'background-color': bgColor, 'color': txtColor}">
		<h2 v-if="title && headTitle" class="head_title" v-html="title"></h2>
		<div class="content_section_inner_text">
			<h2 v-if="title && !headTitle" v-html="title"></h2>
			<div class="list_content" v-bind:class="{simple_column: isOneColumn}" v-bind:style="{ 'text-align': alignText }">
				<ContentListElement
						v-for="contentlistItem in orderBy(contentlistItems,orderlistItem)"
						v-bind:key="contentlistItem.id"
						:associe="contentlistItem.associe"
						:fonction="contentlistItem.fonction"
						:image="contentlistItem.image"
						:name="contentlistItem.name"
						:titre="contentlistItem.titre"
						v-bind:style="{'width': columnsWidth(columns)}"
				>
				</ContentListElement>
				<slot></slot>
			</div>
		</div>
		<div v-if="image" :class="imageClass"
		     :style="{'background-image': 'url(' + require('../assets/images/'+image) + ')'}"
		     class="content_section_inner_image">
		</div>
	</section>

</template>

<script>

import ContentListElement from "@/components/ContentListElement";
import Vue2Filters from "vue2-filters";

export default {
	name: "ContentList",
	mixins: [Vue2Filters.mixin],
	components: {
		ContentListElement
	},
	data: function () {
		return {
			isInline: (this.inline),
			isImage: (this.image),
			isParallax: (this.parallax),
			isOneColumn: (this.columns == 1)
		};
	},
	props: {
		contentlistItems: {
			type: Array
		},
		title: {
			type: String,
			default: ""
		},
		id: {
			type: String,
			default: ""
		},
		columns: {
			type: Number,
			default: 1
		},
		alignText: {
			type: String,
			default: "left"
		},
		orderlistItem: {
			type: String,
			default: "id"
		},
		image: {
			type: String,
			default: ""
		},
		imageClass: {
			type: String,
			default: ""
		},
		inline: {
			type: String,
			default: ""
		},
		parallax: {
			type: String,
			default: ""
		},
		bgColor: {
			type: String,
			default: ""
		},
		txtColor: {
			type: String,
			default: ""
		},
		headTitle: {
			type: String,
			default: ""
		}
	},
	methods: {
		imgPath: function (image) {
			return require("../assets/images/" + image);
		},
		columnsWidth: function (columns) {
			if (columns > 1) {
				columns = 100 / columns;
				return columns + "%";
			}
		}
	},
	mounted() {
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


.content_section {

	background-color: $white;
	color: $black;
	font-size: 2.4rem;
	padding: 5rem;
	text-align: center;

	@include breakpoint(lt-sm) {
		padding: 3.5rem;
	}

	h2 {
		display: inline-block;
		font-family: $IsidoraBold;
		font-size: 4rem;
		margin-bottom: 4rem;
		position: relative;

		&:after {
			background-color: $black;
			bottom: -1.5rem;
			content: '';
			height: 0.4rem;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
			width: 8rem;
		}
	}

	&_inner_text {
		margin: auto;
		max-width: 140rem;
	}

	.list_content {
		display: flex;
		flex-wrap: wrap;
		font-size: 2.4rem;
		justify-content: center;

		@include breakpoint(lt-md) {
		}

		@include breakpoint(lt-sm) {
			text-align: center !important;
		}

		&_element {
			margin-bottom: 2.5rem;
		}

		&.simple_column {
			flex-direction: column;
		}
	}

	&.image_section {
		display: flex;
		flex-wrap: wrap;
		min-height: $viewportheaderHeight;
		padding: 0;

		@include breakpoint(lt-md) {
			min-height: unset;
		}

		.content_section_inner_text {
			box-sizing: border-box;
			display: flex;
			flex: 1;
			flex-direction: column;
			justify-content: center;
			padding: 5rem;
		}

		.content_section_inner_image {
			background-position: center center;
			background-repeat: no-repeat;
			background-size: cover;
			/*background-attachment: fixed;*/
			flex: 1;
			padding: 5rem;
		}

		&.parallax_section {
			.content_section_inner_image {
				background-attachment: fixed;
				background-position: center right;
				background-size: 50% auto;
			}
		}

	}

	&.inline_section {
		.list_content {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;

			&_element {
				display: inline-block;
				line-height: 2em;
				margin-bottom: 0;
				margin-right: 2.5rem;
				position: relative;
				text-transform: uppercase;
				white-space: nowrap;

				&:after {
					content: '•';
					line-height: 1.3em;
					padding: 0.8rem;
					position: absolute;
					vertical-align: middle;
				}

				&:last-of-type {
					&:after {
						content: none;
					}
				}
			}
		}
	}
}

.case {
	.content_section {
		h2 {
			color: $black;
			font-size: 2.8rem;
			margin-bottom: 2rem;

			&:after {
				display: none;
			}
		}

		h3 {
			font-family: $IsidoraSemiBold;
			font-size: 2.2rem;
		}

		&_inner_text {
			max-width: 110rem;
		}

		.list_content {
			color: $black;
			font-family: $IsidoraLight;
			font-size: 2.2rem;
			line-height: 1.3em;
		}
	}
}

</style>
